import { moveToFulfilled, moveToPending, moveToRejected, remove } from '@ms/yammer-data-support';
import { SuggestedActionSurface } from '@ms/yammer-graphql';
import { Reducer } from 'redux';

import { DismissPromptFulfilledAction } from '../../domains/dismissablePrompts/actions.types';
import {
  SuggestedActionsLoadAction,
  SuggestedActionsLoadFulfilledAction,
} from '../../domains/suggestedActions/actions.types';

import { SuggestedAction, SuggestedActions, SuggestedActionsForSurface } from './types';

const loadSuggestedActionFulfilled = (state: SuggestedActions, action: SuggestedActionsLoadFulfilledAction) => {
  const fulfilledUsers: SuggestedAction[] = Object.values(action.payload.entities.followUsers ?? {});
  const fulfilledGroups: SuggestedAction[] = Object.values(action.payload.entities.joinGroups ?? {});

  const map: SuggestedActionsForSurface = {
    id: action.surface,
    followUsers: fulfilledUsers,
    joinGroups: fulfilledGroups,
  };

  return moveToFulfilled(state, { [action.surface]: map });
};

const initialState: SuggestedActions = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

export type SuggestedActionsAction = SuggestedActionsLoadAction | DismissPromptFulfilledAction;

const reducer: Reducer<SuggestedActions, SuggestedActionsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SUGGESTED_ACTION.LOAD_PENDING':
      return moveToPending(state, [action.surface]);
    case 'SUGGESTED_ACTION.LOAD_FULFILLED':
      return loadSuggestedActionFulfilled(state, action);
    case 'SUGGESTED_ACTION.LOAD_REJECTED':
      return moveToRejected(state, [action.surface], action.payload.error);
    case 'DISMISSABLE_PROMPTS.DISMISS_PROMPT_FULFILLED':
      if (action.payload.promptKey === 'LightboxJoinGroups') {
        return remove(state, [SuggestedActionSurface.WEB_LIGHTBOX]);
      }

      return state;
    default:
      return state;
  }
};

export default reducer;
